export class Network {
}
export const getNativeToken = (network) => !network ? undefined : network.tokens?.find(t => t.contract === network.nativeTokenAddress);
export class Token {
}
